import EnrollOrReject from './EnrollOrReject';

export default EnrollOrReject;
